import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  ReportingHistoricalTablePagerService,
  ReportingOverviewService,
  ReportingEmailOverviewService,
  ReportingEmailAvailabilityService,
  ReportingEmailTrendsService,
  ReportingEmailSendersService,
  ReportingEmailLinksService,
  ReportingEmailUsersService,
  ReportingHistoricalTableQueryParamsService,
  ReportingHistoricalTableStateService,
  ReportingHistoricalTableExportService,
  ReportingCallsExportService,
  ReportingCallsChartService,
  ReportingMessagesChartService,
  ReportingEmailTrendsChartService,
  ReportingCallsGridable,
  ReportingMessagesGridable,
  ReportingEmailTrendsGridable,
  ReportingSubAccountsColumnServiceFactory,
  ReportingUsersColumnServiceFactory,
  ReportingNumbersColumnServiceFactory,
  ReportingNumberFilterServiceFactory,
  ReportingCallsColumnServiceFactory,
  ReportingMessagesColumnServiceFactory,
  ReportingEmailTrendsColumnServiceFactory,
  ReportingEmailSendersColumnServiceFactory,
  ReportingEmailLinksColumnServiceFactory,
  ReportingEmailUsersColumnServiceFactory,
  ReportingHistoricalTableFilterServiceFactory,
  ReportingCallsService,
  ReportingHistoricalTableYearsRepository,
  ReportingOverviewRepository,
  ReportingEmailOverviewRepository,
  ReportingEmailAvailabilityRepository,
  ReportingEmailTrendsRepository,
  ReportingEmailSendersRepository,
  ReportingEmailLinksRepository,
  ReportingEmailUsersRepository,
  ReportingSubAccountsRepository,
  ReportingUsersRepository,
  ReportingUsersService,
  ReportingNumbersRepository,
  ReportingCallsRepository,
  ReportingMessagesRepository,
  ReportingMessagesService,
  ReportingDateAndStatusFilterServiceFactory,
  ReportingDateFilterServiceFactory,
  ReportingOverviewFilterServiceFactory,
}

export type ReportingServices = keyof typeof SERVICES

export const REPORTING_SERVICE_TYPES: Record<ReportingServices, symbol> = makeServicesTypes<ReportingServices>(
  enumKeysToArray<ReportingServices>(SERVICES),
)
